export default __webpack_public_path__ + "static/media/human-meta.abb0122d.svg";